import { searchService } from "@/api/search.service";
import { emitterInstance } from "@/classes/emitter";
import { SuggestionItem, useSearchList } from "@/vue_components/product-overview/composables/useSearchList";
import { ref } from "vue";

interface Props {
    placeholder?: string;
    searchLabel?: string;
    isSimpleSearchField:boolean;
}

export function useContentSearchField (
    props: Props,
    emit: {(event: 'search', term: string):void}
){

    const suggestions = ref<SuggestionItem[]>([]);
    const searchTerm = ref('');
    const MINIMUM_SEARCH_LENGTH = 4; 

    const {clearSuggestions} = useSearchList(props, emit);

    const loadSuggestions = async (term:string)=>{
        try {
            const responsePraeparat = await searchService.suggestPraeparatName(term); 
            addSuggestions(responsePraeparat.suggests ? responsePraeparat.suggests : []);

            const responseFulltext = await searchService.suggestFullText(term);            
            addSuggestions(responseFulltext.Suggests ? responseFulltext.Suggests : []);

            const responseContent = await searchService.contentSuggest(term);
            addSuggestions(responseContent.Suggests ? responseContent.Suggests : []);

            const responseMedia = await searchService.mediaSuggest(term);
            addSuggestions(responseMedia.Suggests ? responseMedia.Suggests : []);
        } catch (error) {
            console.error('Fehler beim Laden der Suchvorschläge:', error);
            suggestions.value = [];
        }
    }
    const addSuggestions = (suggests:any[]) => {
        suggests.forEach(suggest => {
            suggestions.value = suggestions.value.concat(new SuggestionItem(suggest));
        });
    }
    const onInput = async () => {
        if (searchTerm.value.length >= MINIMUM_SEARCH_LENGTH) {
            await loadSuggestions(searchTerm.value);
        } else {
            clearSuggestions(suggestions);
        }
    };
    const emitSearch = () => {
        clearSuggestions(suggestions);
        const emitName = props.isSimpleSearchField?"toggleSimpleSearch" : "contentSearch";
        emitterInstance.emit(emitName, searchTerm.value);
    };

    

    return{      
        searchTerm,  
        suggestions,
        onInput,
        emitSearch,
    };
}